export default "__VITE_ASSET__DOo1Nvcx__"